import React from "react";
import PropTypes from "prop-types";
import styles from "./WorkList.module.css";
import "../../../css/flex.css";
import Tablist from "./TabList/Tablist";
import WorkItem from "./WorkItem";
import Searchbox from "./Searchbox/Searchbox";
import HomeWorkListStateDropdownContainer from "containers/home/WorkList/StateDropdownContainer";
import UITable from "components/UI/Table";
import Pagination from "./Pagination";
import {
  Filters,
  SortTH,
  HTRow,
  Table,
  TableContainer,
  ContentContainer,
  RetryWrapper
} from "./WorkList.styles";
import WorkListEmpty from "./Empty";
import IconTable from "components/Icon/Table";
import FeatureRenderer from "components/Feature/RendererContainer";
import PrimaryButton from "../../../components/UI/Button/Primary";
import SkeletonWorkList from "./SkeletonWorkList";
import { useTransition, animated } from "react-spring";

const apiColumns = {
  "Claim #": "Claim",
  "Insured Name": "Insurer",
  Vehicle: "Vehicle",
  State: "State",
  "Loss Date": "DateOfLoss",
  "Creation Date": "Creation Date",
  Status: "Status"
};

const renderHeader = ({ id, active, order, onClickHeader }) => {
  const apiCol = apiColumns[id];

  return active ? (
    id === "Actions" ? (
      <FeatureRenderer feature="FeesActions" key={id}>
        <th className="fees__header">Actions</th>
      </FeatureRenderer>
    ) : (
      <SortTH
        key={id}
        className="fees__header"
        onClick={() => onClickHeader(apiCol)}
        sort={order.field === apiCol ? order.type : null}
        id={id}
      >
        {id}
      </SortTH>
    )
  ) : null;
};

const Retry = ({ fetchData }) => {
  return (
    <RetryWrapper>
      <PrimaryButton onClick={fetchData}>Please Try Again</PrimaryButton>
    </RetryWrapper>
  );
};

const WorkList = ({
  items,
  order,
  onClickItem,
  onClickHeader,
  onClickClone,
  selectedFilter,
  toggleColumnPicker,
  columnConfig,
  onTabChange,
  loading,
  error,
  fetchData,
  ...rest
}) => {
  const table = (
    <TableContainer>
      <Table className="fees__table">
        <thead>
          <HTRow>
            {columnConfig.map(({ id, active }) =>
              renderHeader({ id, active, order, onClickHeader })
            )}
          </HTRow>
        </thead>
        <tbody>
          {items.map((item, row) => (
            <WorkItem
              row={row}
              key={item.id}
              item={item}
              columnConfig={columnConfig}
              onClick={onClickItem}
              onClone={onClickClone}
            />
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );

  const transitions = useTransition(loading, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 }
  });

  return (
    <div className={`fees ${styles.base}`}>
      {transitions.map(({ item, key, props: style }) =>
        item ? (
          <animated.div className={styles.table} style={style} key={key}>
            <SkeletonWorkList />
          </animated.div>
        ) : (
          <animated.div className={styles.table} style={style} key={key}>
            <>
              <div className={styles.header}>
                <Tablist
                  className={styles.tabs}
                  items={["In Progress", "Completed"]}
                  onChange={onTabChange}
                  {...rest}
                />
                <Filters>
                  <HomeWorkListStateDropdownContainer id="Search_by_state" data-state-filter />
                  <Searchbox />
                </Filters>
                <IconTable title="Pick columns" onClick={toggleColumnPicker} id="options" />
              </div>

              <ContentContainer>
                {error ? (
                  <Retry fetchData={fetchData} />
                ) : items.length ? (
                  table
                ) : (
                  <WorkListEmpty />
                )}
              </ContentContainer>

              {!error && items.length ? (
                <UITable.Footer>
                  <Pagination />
                </UITable.Footer>
              ) : null}
            </>
          </animated.div>
        )
      )}
    </div>
  );
};

WorkList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedFilter: PropTypes.string,
  order: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.oneOf(["asc", "desc"])
  }),
  onClickItem: PropTypes.func,
  onClickHeader: PropTypes.func,
  onClickClone: PropTypes.func,
  toggleColumnPicker: PropTypes.func,
  columnConfig: PropTypes.array.isRequired,
  onTabChange: PropTypes.func,
  error: PropTypes.any,
  loading: PropTypes.bool,
  fetchData: PropTypes.func.isRequired
};

WorkList.defaultProps = {
  selectedFilter: "In Progress",
  onClickItem: () => {},
  onClickHeader: () => {},
  onClickClone: () => {},
  toggleColumnPicker: () => {},
  onTabChange: () => {}
};

export default WorkList;
